import { render, staticRenderFns } from "./CovidApp.vue?vue&type=template&id=3cd1350c&"
import script from "./CovidApp.vue?vue&type=script&lang=js&"
export * from "./CovidApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports